import React, { Fragment, useState, useEffect, useContext } from 'react'
import { useForm } from "react-hook-form";
import { Link } from 'react-router-dom'

import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { breadcrumbsBy, locationSearchCity } from '../../services/locations'
import { currencies } from '../../services/exchangeRate'

import useToastContext from "../../hooks/useToastContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from "react-helmet-async";
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead'

const LocationSettings = ({ user }) => {

    const { authServices, setAppState } = useContext(AppContext)
    const addToast = useToastContext()

    const [ location, setLocation ] = useState(null)
    const [ locations, setLocations ] = useState([])
    const [ locationsLoading, setLocationsLoading ] = useState(false)
    const [ currency, setCurrency ] = useState(user?.default_currency)
    const [ profileType, setProfileType ] = useState(user?.profile_type)

    const defaultLocation = user && user.default_location && user.default_location.location ? (user.default_location.name + ', ' + user.default_location.location.name) : null

    const [ loading, setLoading ] = useState(false)
    const [ editing, setEditing ] = useState(false)
    const [ editType, setEditType ] = useState(null)

    const udpateUser = data => {
        setLoading(true)
        return authServices.update(data).then(res => {
            setAppState('app.user', res.user)
            setLoading(false)
            setEditing(false)
            addToast({title: 'Success', message: 'Location Settings saved successfully', type: 'success'})
            return true
        }).catch(res => {
            setLoading(false)
            if(res.data){
                if(res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
            }
            return false
        })
    }

    if(!user) return null

    return (
        <div className="card h-100">
            <div className="card-body d-flex flex-column">
                <h5 className="card-title">Defaults</h5>
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                {!editing &&
                    <div className="row mb-3">
                        <div className="col-md-3">Location:</div>
                        <div className="col-md-6">{defaultLocation ? defaultLocation : 'not set'}</div>
                        {!editing &&
                            <div className="col-md-3 text-right">
                                <a href="" className="h6" onClick={e => {
                                    e.preventDefault()
                                    setEditing(true)
                                    setEditType('location')
                                }}>change</a>
                            </div>
                        }
                    </div>
                }

                {(user.default_currency && !editing) &&
                    <div className="row mb-3">
                        <div className="col-md-3">Currency:</div>
                        <div className="col-md-6">{user.default_currency}</div>
                        {!editing &&
                            <div className="col-md-3 text-right">
                                <a href="" className="h6" onClick={e => {
                                    e.preventDefault()
                                    setEditing(true)
                                    setEditType('currency')
                                }}>change</a>
                            </div>
                        }
                    </div>
                }

                {false && !editing &&
                    <div className="row mb-3">
                        <div className="col-md-3">Profile Type:</div>
                        <div className="col-md-6">{user.profile_type == 0 ? 'Personal' : 'Business'}</div>
                        {!editing &&
                            <div className="col-md-3 text-right">
                                <a href="" className="h6" onClick={e => {
                                    e.preventDefault()
                                    setEditing(true)
                                    setEditType('profile-type')
                                }}>change</a>
                            </div>
                        }
                    </div>
                }

                {user.profile_type == 1 && !editing &&
                    <div className="row mb-3">
                        <div className="col-md-9">Business Profile:</div>
                        <div className="col-md-3 text-right">
                            <Link tag="a" to="/account/business-profile" className="h6">edit</Link>
                        </div>
                    </div>
                }


                {!loading && (editing || !defaultLocation) && editType == 'location' &&
                    <div className="mb-3">

                        <AsyncTypeahead
                            filterBy={() => true}
                            id="select-location"
                            isLoading={locationsLoading}
                            labelKey={item => {
                                return [item.name, item.location.name, item.location.location.name].join(', ')
                            }}
                            onSearch={query => {
                                setLocationsLoading(true)
                                locationSearchCity(query).then(res => {
                                    setLocations(res)
                                    setLocationsLoading(false)
                                }).catch(() => setLocationsLoading(false))
                            }}

                            inputProps={{className: 'form-control', placeholder: 'Type new default location name'}}
                            onChange={selected => {
                                const selectedLocation = selected[0]
                                if(selectedLocation && selectedLocation.id){
                                    udpateUser({default_location_id: selectedLocation.id})
                                }
                            }}
                            options={locations}
                        />
                        {!!defaultLocation &&
                            <div className="text-right">
                                <a href="" className="h6" onClick={e => {
                                    e.preventDefault()
                                    setEditing(false)
                                }}>Cancel</a>
                            </div>
                        }
                    </div>
                }

                {!loading && editing && editType == 'currency' &&
                    <div className="mb-3">
                        <label>Select currency: </label>
                        {currencies &&
                            <Typeahead
                                id="price-currency-id"
                                labelKey={option => `${option.key} (${option.label})`}
                                inputProps={{
                                    className: 'form-control mb-3 mb-md-0',
                                    placeholder: 'Currency',
                                    autoComplete: 'do-not-autocomplete-this-please',
                                    onClick: e => {
                                        setCurrency(null)
                                    }
                                }}
                                onChange={selected => setCurrency(selected[0]?.key)}
                                selected={currency ? [{key: currency, label: currencies[currency]}] : []}
                                options={Object.keys(currencies).map(key => { return {key: key, label: currencies[key]}})}
                            />
                        }
                        <div className="text-right mt-2">
                            <button
                                className="btn btn-light border me-2"
                                onClick={e => {
                                    e.preventDefault()
                                    setEditing(false)
                                }}
                            >Cancel</button>
                            <button
                                className="btn btn-primary"
                                onClick={e => {
                                    e.preventDefault()
                                    udpateUser({default_currency: currency}).then(res => {
                                        if(res) setEditing(false)
                                    })
                                }}
                            >Submit</button>
                        </div>

                    </div>
                }

                {!loading && editing && editType == 'profile-type' &&
                    <div className="mb-3">
                        <label>Select Profile Type: </label>
                        <select
                            className="form-select"
                            onChange={e => {
                                setProfileType(e.target.value)
                            }}
                            value={profileType}
                        >
                            <option value="0">Personal</option>
                            <option value="1">Business</option>
                        </select>
                        <div className="text-right mt-2">
                            <button
                                className="btn btn-light border me-2"
                                onClick={e => {
                                    e.preventDefault()
                                    setEditing(false)
                                }}
                            >Cancel</button>
                            <button
                                className="btn btn-primary"
                                onClick={e => {
                                    e.preventDefault()
                                    udpateUser({profile_type: profileType}).then(res => {
                                        if(res) setEditing(false)
                                    })
                                }}
                            >Submit</button>
                        </div>

                    </div>
                }

                {loading && <div className="text-center"><FontAwesomeIcon icon={faSpinner} className="fa-spin" /></div>}
                </div>

            </div>

        </div>        
    )
}

const BasicSettings = ({ user }) => {

    const { authServices, setAppState } = useContext(AppContext)

    const [ loading, setLoading ] = useState(false)

    const { register, handleSubmit, watch, errors, setError } = useForm();
    const addToast = useToastContext()

    const onSubmit = data => {
        setLoading(true)
        authServices.update(data).then(res => {
            setAppState('app.user', res.user)
            setLoading(false)            
            addToast({title: 'Success', message: 'Settings saved successfully', type: 'success'})
        }).catch(res => {
            setLoading(false)
            if(res.data){
                if(res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
                if(res.data.errors){
                    const keys = Object.keys(res.data.errors)
                    for(var i = 0; i < keys.length; i ++){
                        setError(keys[i], {
                            type: "manual",
                            message: res.data.errors[keys[i]].join('. ')
                        })
                    }
                }
            }
        })
    };

    if(!user) return null

    return (
        <div className="card h-100">

            <form className="card-body" onSubmit={handleSubmit(onSubmit)}>
                <h5 className="card-title">Basic Settings</h5>
                <div className="mb-3">
                    <label>Name</label>
                    <input
                        type="text"
                        className={"form-control" + (errors.name ? ' is-invalid' : '')}
                        name="name"
                        placeholder="Name"
                        defaultValue={user.name}
                        ref={register({ required: true, message: 'asdf' })}
                    />
                    {errors.name && <div className="invalid-feedback d-block">{errors.name.message}</div>}
                    {errors.name && errors.name.type === "required" && <div className="invalid-feedback d-block">This is required</div>}
                </div>

                <div className="mb-3">
                    <label>Email</label>
                    <input
                        type="email"
                        readOnly={true}
                        className="form-control"
                        name="email"
                        placeholder="Email"
                        defaultValue={user.email}
                    />
                </div>

                <div className="d-flex justify-content-end">
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                        {loading && <FontAwesomeIcon icon={faSpinner} className="fa-spin" />}
                        {!loading && <FontAwesomeIcon icon={faCloudUploadAlt} />}
                        <span className="ms-2">Save</span>
                    </button>
                </div>

            </form>

        </div>
    )
}

const Settings = ({ match, history }) => {

    const { data, location } = useContext(AppContext)
    const { app } = data
    const { user } = app

    const title = "Settings"

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <h1>{title}</h1>

                        <div className="row row-eq-height">
                            <div className="col-lg-6 col-xl-6 mb-3">
                                <BasicSettings user={user} />
                            </div>
                            <div className="col-lg-6 col-xl-6 mb-3">
                                <LocationSettings user={user} />
                            </div>
                        </div>

                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Settings
